import { Button as ReactButton } from 'devextreme-react/button';
import { DateBox } from 'devextreme-react/date-box';
import NumberBox from 'devextreme-react/number-box';
import { Popup, ToolbarItem } from 'devextreme-react/popup';
import ScrollView from 'devextreme-react/scroll-view';
import TabPanel, { Item } from 'devextreme-react/tab-panel';
import { TextBox, Button as TextBoxButton } from 'devextreme-react/text-box';
import React, { useEffect, useState } from 'react';
import { useAppContext } from '../shared/AppContext';
import GrantDetailsExternalUsers from './GrantDetailsExternalUsers';
import GrantUserSelect from './GrantUserSelect';
import RiskMeter, { RiskMeterPresets } from '../shared/riskMeter/RiskMeter';
import Overview from './modules/overview/Overview';
import VisTimeline from './progressTimeline/vis/VisTimeline';
import Notes from './notes/Notes';
import AddNoteDialog from './notes/AddNoteDialog';
import moment from 'moment';

//TODO fix any
export default function GrantDetailHeader({ grantData, phaseData, setShortInstitution, setShortTitle, setBudgetEnd }: any) {
    const app = useAppContext();

    const [externalUserAccess, setExternalUserAccess] = useState(false);
    const [showExternalUsersPopup, setShowExternalUsersPopup] = useState(false);
    const [soSelectVisible, setSoSelectVisible] = useState(false);
    const [selectedTabIndex, setSelectedTabIndex] = useState(0);
    const [addNoteVisible, setAddNoteVisible] = useState(false);
    // Bumped on save so the Notes tab grid and the Progress timeline both reload to show the new note.
    const [notesRefreshToken, setNotesRefreshToken] = useState(0);

    // Handle deep link to Risk Meter tab (wait for grantData to be available)
    useEffect(() => {
        if (!grantData?.id) return;
        const hash = window.location.hash.toLowerCase().replace('#', '');
        if (hash === 'riskmeter') {
            setSelectedTabIndex(4);
            window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}`);
        } else if (hash === 'overview') {
            setSelectedTabIndex(phaseData?.riskMeterData ? 5 : 4);
            window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}`);
        }
    }, [grantData?.id]);

    const onShowExternalUsersPopup = (e: any) => {
        setShowExternalUsersPopup(true);
    }

    const onOkPopupClick = (e: any): boolean => {
        setShowExternalUsersPopup(false);
        return true;
    }

    const getGrantDetailsTitle = () => {
        if (grantData && grantData.fy) {
            return grantData.fy + ' - ' + grantData.institution;
        } else {
            return "";
        }
    }

    useEffect(() => {
        const externalUserAccess = () => {
            let allowAccess = false;

            if (app.userPermissions.allowManageExternalUsers) {
                allowAccess = true;
            } else if (app.externalUserRoles !== null) {
                const grantExternalUserAccess = app.externalUserRoles[grantData.id];

                if (grantExternalUserAccess !== undefined) {
                    for (var i = 0; i < grantExternalUserAccess.length; i++) {
                        const access = grantExternalUserAccess[i];

                        if (access.allowManageExternalUsers) {
                            allowAccess = true;
                        }
                    }
                }
            }

            setExternalUserAccess(allowAccess);
        }

        const closeOnEscapePressed = (e: any) => {
            if (e.key === "Escape") {
                setShowExternalUsersPopup(false);
            }
        };

        externalUserAccess();

    }, [grantData])

    useEffect(() => {
        const closeOnEscapePressed = (e: any) => {
            if (e.key === "Escape") {
                setShowExternalUsersPopup(false);
            }
        };

        window.addEventListener("keydown", closeOnEscapePressed);
        return () =>
            window.removeEventListener("keydown", closeOnEscapePressed);
    }, [])

    const canAssign = () => {

        var assign = false;

        if (app.UserIsPO || app.UserIsSuper || app.UserIsPI) {
            assign = true;
        }

        return assign;
    }

    const soTextBoxButtonOptions = {
        disabled: !canAssign(),
        icon: 'search',
        stylingMode: 'text',
        onClick: () => {
            setSoSelectVisible(true);
        }
    };

    const hideSoSelect = (): boolean => {
        setSoSelectVisible(false);
        return true;
    }

    const setUpdatedSo = (data: any) => {
        var aor = data.firstName + " " + data.lastName;
        grantData.aor = aor.trim();
        grantData.aorEmailAddress = data.email;
    }

    const cancelSoAssignmentOptions = {
        text: 'Cancel',
        stylingMode: 'outlined',
        type: 'normal',
        onClick: hideSoSelect,
    };

    const budgetDateResetButtonOptions = {
        hint: `Revert the value to: ${grantData?.budgetEndDate}`,
        location: "after",
        icon: "revert",
        stylingMode: "text",
        onClick: () => { setBudgetEnd(grantData?.budgetEndDate) }
    }

    const shortInstitutionResetButtonOptions = {
        hint: `Revert the value to: ${grantData?.institution}`,
        location: "after",
        icon: "revert",
        stylingMode: "text",
        onClick: () => { setShortInstitution(grantData?.institution); },
        disabled: !app.userPermissions.allowChangeTitleInstitution,
        visible: grantData?.institution != grantData?.shortInstitution
    };

    const shortTitleResetButtonOptions = {
        hint: `Revert the value to: ${grantData?.title}`,
        location: "after",
        icon: "revert",
        stylingMode: "text",
        onClick: () => { setShortTitle(grantData?.title) },
        disabled: !app.userPermissions.allowChangeTitleInstitution,
        visible: grantData?.title != grantData?.shortTitle
    };

    if (!grantData) {
        return null;
    } else {
        return (
            <>
                <Popup
                    visible={showExternalUsersPopup}
                    dragEnabled={false}
                    position="center"
                    hideOnOutsideClick={onOkPopupClick}
                    onHiding={onOkPopupClick}
                    showCloseButton={false}
                    showTitle={true}
                    title="Manage Users"
                    width={705}
                    height="auto"
                    maxHeight="90vh" >
                    <ScrollView height="91%" width="100%">
                        <div className="row popupRow">
                            <div className="dx-field col-12">
                                <GrantDetailsExternalUsers
                                    canAssign={canAssign()}
                                    grantId={grantData.id}
                                    grantAor={grantData.aor}
                                    grantAorEmail={grantData.aorEmailAddress}
                                    popupLoaded={showExternalUsersPopup}
                                    setSoSelectVisible={setSoSelectVisible}
                                />
                            </div>
                        </div>
                    </ScrollView>
                    <div className="row">
                        <div className="dx-field col-12" style={{ paddingTop: '10px' }}>
                            <ReactButton
                                width={100}
                                className="externalUsersOkButton"
                                text="Ok"
                                onClick={onOkPopupClick} />
                        </div>
                    </div>
                </Popup>
                <div style={{ position: 'relative' }}>
                    <div style={{ position: 'absolute', top: 10, right: 18, zIndex: 1 }}>
                        <ReactButton
                            className="add-note-button"
                            icon="add"
                            text="Add Note"
                            type="default"
                            stylingMode="contained"
                            height={20}
                            elementAttr={{ style: 'font-size: 11px;' }}
                            onClick={() => setAddNoteVisible(true)}
                        />
                    </div>
                <TabPanel id='grantVisualizationsPanel' selectedIndex={selectedTabIndex} onSelectedIndexChange={setSelectedTabIndex}>
                    <Item title={getGrantDetailsTitle()} >
                        <div className="container-fluid panelBody">
                            <div className="row grantDetailsRow" style={{ display: "grid", gridTemplateColumns: ".7fr 1.2fr 1.4fr 3fr 5.7fr", gap: "0px" }}>
                                <div className="dx-field">
                                    <div className="dx-field-label">Fiscal Year</div>
                                    <div className="grantDetails-created-value">
                                        <div className="dx-widget dx-field dx-texteditor-input">
                                            {grantData.fy}
                                        </div>
                                    </div>
                                </div>
                                <div className="dx-field">
                                    <div className="dx-field-label">Budget End Date</div>
                                    <div className="grantDetails-created-value">
                                        <div className="dx-widget dx-field dx-texteditor-input">
                                            {grantData.budgetEndDate && moment(grantData.budgetEndDate).format("MM-DD-YYYY")}
                                        </div>
                                    </div>
                                </div>
                                <div className="dx-field">
                                    <div className="dx-field-label">Grant Number</div>
                                    <div className="grantDetails-created-value">
                                        <div className="dx-widget dx-field dx-texteditor-input" style={{ textDecoration: 'underline', cursor: 'pointer' }}>
                                            <a style={{ color: '#000' }} href={`https://apps.era.nih.gov/qvr/web/dd_projecthistory.cfm?ApplId=${grantData.applicationId}`} target='_blank'>{grantData.grantNumber}</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="dx-field">
                                    <div className="dx-field-label">Institution</div>
                                    <div className="grantDetails-created-value">
                                        <TextBox
                                            value={grantData.shortInstitution}
                                            onChange={(e: any) => { setShortInstitution(e.event.target.value) }}
                                            disabled={!app.userPermissions.allowChangeTitleInstitution}>
                                            <TextBoxButton name="ShortInstitutionResetButton"
                                                options={shortInstitutionResetButtonOptions} />
                                        </TextBox>
                                    </div>
                                </div>
                                <div className="dx-field">
                                    <div className="dx-field-label">Project Title</div>
                                    <div className="grantDetails-created-value">
                                        <TextBox
                                            value={grantData.shortTitle}
                                            onChange={(e: any) => { setShortTitle(e.event.target.value) }}
                                            disabled={!app.userPermissions.allowChangeTitleInstitution}>
                                            <TextBoxButton name="ShortTitleResetButton"
                                                options={shortTitleResetButtonOptions} />
                                        </TextBox>
                                    </div>
                                </div>
                            </div>
                            <div className="row grantDetailsRow" style={{ display: "grid", gridTemplateColumns: "2.5fr 2.5fr 2.5fr 2.5fr 1fr 1fr", gap: "0px" }}>
                                <div className="dx-field">
                                    <div className="dx-field-label">SO</div>
                                    <div className="grantDetails-created-value">
                                        <TextBox id="soTextBox" value={grantData.aor} readOnly={true}>
                                            <TextBoxButton name="soSelect" options={soTextBoxButtonOptions}></TextBoxButton>
                                        </TextBox>
                                    </div>
                                </div>
                                <div className="dx-field">
                                    <div className="dx-field-label">GMS</div>
                                    <div className="grantDetails-created-value">
                                        <div className="dx-widget dx-field dx-texteditor-input">
                                            {grantData.gms}
                                        </div>
                                    </div>
                                </div>
                                <div className="dx-field">
                                    <div className="dx-field-label">PI</div>
                                    <div className="grantDetails-created-value">
                                        <div className="dx-widget dx-field dx-texteditor-input">
                                            {grantData.pi}
                                        </div>
                                    </div>
                                </div>
                                <div className="dx-field">
                                    <div className="dx-field-label">PO</div>
                                    <div className="grantDetails-created-value">
                                        <div className="dx-widget dx-field dx-texteditor-input">
                                            {grantData.po}
                                        </div>
                                    </div>
                                </div>
                                <div className="dx-field">
                                    <div className="dx-field-label">FOA/NOFO</div>
                                    <div className="grantDetails-created-value">
                                        <div className="dx-widget dx-field dx-texteditor-input">
                                            {grantData.foA_NOFO}
                                        </div>
                                    </div>
                                </div>
                                <div className="dx-field">
                                    <div className="dx-field-label">&nbsp;</div>
                                    <div>
                                        <ReactButton
                                            disabled={!externalUserAccess}
                                            height="100%"
                                            hint="Manage users"
                                            icon="group"
                                            onClick={onShowExternalUsersPopup}
                                            stylingMode="contained"
                                            type="default"
                                            width="100%"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Item>

                    <Item title='&nbsp;Progress'>
                        <VisTimeline grantData={grantData} refreshToken={notesRefreshToken} />
                    </Item>

                    {phaseData?.riskMeterData && (
                        <Item title='&nbsp;Risk Meter'>
                            <RiskMeter
                                data={phaseData.riskMeterData}
                                grantId={grantData.id}
                                {...RiskMeterPresets.full}
                                screenshotTitle={`${grantData.fy} - ${grantData.grantNumber} - ${grantData.shortInstitution}`}
                                screenshotFilename={`${grantData.grantNumber}_RiskMeter.png`}
                            />
                        </Item>
                    )}

                    <Item title='&nbsp;Overview'>
                        <Overview grantData={grantData} />
                    </Item>

                    <Item title='&nbsp;Notes'>
                        <Notes
                            grantData={grantData}
                            refreshToken={notesRefreshToken}
                            onNotesChanged={() => setNotesRefreshToken(t => t + 1)}
                        />
                    </Item>
                </TabPanel>
                </div>

                <AddNoteDialog
                    grantData={grantData}
                    visible={addNoteVisible}
                    onClose={() => setAddNoteVisible(false)}
                    onSaved={() => setNotesRefreshToken(t => t + 1)}
                />

                <Popup
                    height={400}
                    hideOnOutsideClick={hideSoSelect}
                    onHiding={hideSoSelect}
                    title="Assign SO"
                    visible={soSelectVisible}
                    width={750}
                >
                    <GrantUserSelect
                        grantId={grantData.id}
                        hideSoSelect={hideSoSelect}
                        setUpdatedSo={setUpdatedSo}
                    >
                    </GrantUserSelect>
                    <ToolbarItem
                        widget="dxButton"
                        toolbar="bottom"
                        location="after"
                        options={cancelSoAssignmentOptions}
                    ></ToolbarItem>
                </Popup>
            </>
        );
    }
};